export const DOC2SPEACH_ALLOWED_DOCS_EXTENSIONS: string = '.pdf,.doc,.docx,.xls,.xlsx,.xlsm,.ppt,.pptx,.odt,.ods,.odp,.rtf,.csv,.txt,.xml,.html,.md,.key,.pages';
export const DOC2SPEACH_ALLOWED_IMAGES_EXTENSIONS: string = '.jpg,.jpeg,.png,.webp,.svg,.bmp,.avif,.tif,.tiff';
export const DOC2SPEACH_ALLOWED_VIDEOS_EXTENSIONS: string = 'video/*';

export const getDoc2SpeachAllowedExtensions = (visionEnabled: boolean = false) => {
  const baseTypes = `${DOC2SPEACH_ALLOWED_IMAGES_EXTENSIONS},${DOC2SPEACH_ALLOWED_DOCS_EXTENSIONS}`;
  return visionEnabled ? `${baseTypes},${DOC2SPEACH_ALLOWED_VIDEOS_EXTENSIONS}` : baseTypes;
}
